"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InlineExpander = void 0;
var react_1 = __importStar(require("react"));
var inline_expander_styles_1 = require("./inline_expander.styles");
var storm_ui_1 = require("@amzn/storm-ui");
var InlineExpander = function (props) {
    var labelName = props.labelName, children = props.children;
    var _a = (0, react_1.useState)(props.isOpen), isOpen = _a[0], setIsOpen = _a[1];
    var handleClick = function () {
        setIsOpen(function (prev) { return !prev; });
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(inline_expander_styles_1.ExpanderHead, { onClick: handleClick, "aria-expanded": isOpen },
            react_1.default.createElement(inline_expander_styles_1.TextButtonLabel, null, labelName),
            react_1.default.createElement(inline_expander_styles_1.IconWrapper, null,
                react_1.default.createElement(storm_ui_1.Icon, { type: isOpen ? 'angle-up' : 'angle-down', size: "lg" }))),
        react_1.default.createElement(inline_expander_styles_1.ExpanderContent, { isOpen: isOpen }, children)));
};
exports.InlineExpander = InlineExpander;
